<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'user')"

  >

    <template #addDataForm>
      <user-add-update></user-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">
      <template v-if="cell.field.key === 'user'">
          <template v-if="get(cell.item, 'id')">
            <user-cell :user="cell.item"></user-cell>
          </template>
          <template v-else>
            {{cell.value}}
          </template>
      </template>
    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../userStoreModule'
  import useUser from '../useUser'

  import UserAddUpdate from '../components/UserAddUpdate'
  import UserCell from "../components/UserCell";

  import get from 'lodash.get'

  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
      UserCell,
      ElementsLayout,
      UserAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = useUser();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
